import tippy, {createSingleton} from 'tippy.js';

export const initTippy = (selector = '.js-tippy', options = {}) => {
    const offsetTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) + 20

    for (const el of [...document.querySelectorAll(selector)].filter(el => !el._tippy)) {
        tippy(el, {...{
            content: el.dataset.tippyContent,
            animation: 'shift-away',
            theme: 'general',
            placement: 'top',
            allowHTML: true,
            interactive: true,
            zIndex: parseInt(el.dataset.tippyZIndex) || 99,
            interactiveBorder: 24,
            appendTo: () => document.body,
            popperOptions: {
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['bottom'],
                            padding: {
                                top: offsetTop,
                                right: 10,
                                bottom: 10,
                                left: 10
                            }
                        },
                    },
                ],
            },
        }, ...options})
    }

    for (const holder of [...document.querySelectorAll('.js-singleton-holder')].filter(el => !el.classList.contains('is-singleton-initialized'))) {
        const singletonInstances = []

        for (const el of holder.querySelectorAll(selector)) {
            if (el._tippy) {
                singletonInstances.push(el._tippy)
            }
        }

        if (singletonInstances.length) {
            createSingleton(singletonInstances, {
                delay: [200, 0],
                overrides: [
                    'content',
                    'animation',
                    'theme',
                    'placement',
                    'allowHTML',
                    'interactive',
                    'zIndex',
                    'interactiveBorder',
                    'interactiveDebounce',
                    'appendTo',
                    'popperOptions',
                ]
            })
        }

        holder.classList.add('is-singleton-initialized')
    }
}

export const initTippyDropdown = (options = {}) => {
    const offsetTop =
        parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) +
        20;

    for (const el of document.querySelectorAll(".js-tippy-dropdown:not(.is-initialized)")) {
        const triggerEl = el.querySelector(".js-tippy-dropdown-trigger");
        const dropdownEl = el.querySelector(".js-tippy-dropdown-target");

        dropdownEl.style.display = null;

        tippy(triggerEl, {
            ...{
                content: dropdownEl,
                animation: "shift-away",
                theme: "dropdown",
                placement: "top-start",
                allowHTML: true,
                interactive: true,
                zIndex: 299,
                maxWidth: 600,
                interactiveBorder: 24,
                trigger: "click",
                popperOptions: {
                    modifiers: [
                        {
                            name: "flip",
                            options: {
                                fallbackPlacements: ["top-end", "bottom-start", "bottom-end"],
                                //? Only if header is sticky
                                // padding: {
                                //     top: offsetTop,
                                //     right: 10,
                                //     bottom: 10,
                                //     left: 10
                                // }
                            },
                        },
                    ],
                },
            },
            ...options,
        });

        el.classList.add("is-initialized");
    }
};